import template from './profilePage.html';
import controller from './profilePage.controller';
import './profilePage.scss';

let profilePageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default profilePageComponent;
